/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DocumentEntityTypesEnum } from '../models/DocumentEntityTypesEnum';
import type { DocumentTypesEnum } from '../models/DocumentTypesEnum';
import type { DocumentVMIEnumerableResponseVM } from '../models/DocumentVMIEnumerableResponseVM';
import type { DocumentVMResponseVM } from '../models/DocumentVMResponseVM';
import type { StringResponseVM } from '../models/StringResponseVM';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DocumentService {
    /**
     * @param entityId
     * @param entityType
     * @param documentTypeId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns DocumentVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiDocumentList(
        entityId: number,
        entityType: DocumentEntityTypesEnum,
        documentTypeId: DocumentTypesEnum,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<DocumentVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Document/{entityId}/{entityType}/{documentTypeId}/list',
            path: {
                'entityId': entityId,
                'entityType': entityType,
                'documentTypeId': documentTypeId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param entityId
     * @param entityType
     * @param documentTypeId
     * @param pageSize
     * @param pageNumber
     * @param skipValue
     * @param fullyQualifiedFilters
     * @param fullyQualifiedSorts
     * @returns DocumentVMIEnumerableResponseVM Success
     * @throws ApiError
     */
    public static getApiDocumentBase64(
        entityId: number,
        entityType: DocumentEntityTypesEnum,
        documentTypeId: DocumentTypesEnum,
        pageSize?: number,
        pageNumber?: number,
        skipValue?: number,
        fullyQualifiedFilters?: string,
        fullyQualifiedSorts?: string,
    ): CancelablePromise<DocumentVMIEnumerableResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Document/{entityId}/{entityType}/{documentTypeId}/base64',
            path: {
                'entityId': entityId,
                'entityType': entityType,
                'documentTypeId': documentTypeId,
            },
            query: {
                'PageSize': pageSize,
                'PageNumber': pageNumber,
                'SkipValue': skipValue,
                'FullyQualifiedFilters': fullyQualifiedFilters,
                'FullyQualifiedSorts': fullyQualifiedSorts,
            },
        });
    }
    /**
     * @param documentId
     * @returns any Success
     * @throws ApiError
     */
    public static getApiDocument(
        documentId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Document/{documentId}',
            path: {
                'documentId': documentId,
            },
        });
    }
    /**
     * @param documentId
     * @returns StringResponseVM Success
     * @throws ApiError
     */
    public static deleteApiDocument(
        documentId: number,
    ): CancelablePromise<StringResponseVM> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Document/{documentId}',
            path: {
                'documentId': documentId,
            },
        });
    }
    /**
     * @param documentId
     * @returns DocumentVMResponseVM Success
     * @throws ApiError
     */
    public static getApiDocumentDetails(
        documentId: number,
    ): CancelablePromise<DocumentVMResponseVM> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Document/{documentId}/details',
            path: {
                'documentId': documentId,
            },
        });
    }
    /**
     * @param documentId
     * @returns any Success
     * @throws ApiError
     */
    public static getApiDocumentBase641(
        documentId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Document/{documentId}/base64',
            path: {
                'documentId': documentId,
            },
        });
    }
    /**
     * @param formData
     * @returns DocumentVMResponseVM Success
     * @throws ApiError
     */
    public static postApiDocument(
        formData?: {
            Id?: number;
            EntityTypeId?: DocumentEntityTypesEnum;
            EntityId: number;
            DocumentTypeId: DocumentTypesEnum;
            FileName: string;
            Document?: Blob;
            IsMain?: boolean;
            Description?: string;
            DocNumber?: string;
            Base64?: string;
            ValidUntil?: string;
            DocumentFilePath?: string;
            Created?: string;
            Formatted?: Record<string, any>;
        },
    ): CancelablePromise<DocumentVMResponseVM> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Document',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
}
